import { Phone } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PHONE_TEL } from "@/site";

/** Mobile-only fixed bottom bar: one tap to call the restaurant. */
export default function FloatingCall() {
  const { t } = useLang();

  return (
    <a
      href={PHONE_TEL}
      data-testid="floating-call-btn"
      className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-center gap-3 bg-gold py-4 text-[13px] font-semibold uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-gold-light lg:hidden"
      style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}
    >
      <Phone size={16} />
      {t.floating}
    </a>
  );
}
